import React from 'react';
import {Modal, Button, Row, Col} from 'antd';
import PropTypes from 'prop-types';
import {Field, getFormValues, isPristine, reduxForm} from "redux-form";
import validate from "./validate";
import asyncValidate from "./asyncValidate";
import {renewedCalculate} from "../../../Module";
import MaterialIcon from "../../../../../../../components/common/MaterialIcon";
import {Date} from "../../../../../../../components/redux-form";
import Position from "../../../../../../../components/FormBuilder/common/Position/Position";
import moment from "moment-jalaali";
import {connect} from "react-redux";


@reduxForm({
  form: 'renewed-report-builder-form',
  validate,
  asyncValidate,
  onSubmit: (values, dispatch, props) => {
    dispatch(renewedCalculate( values, (err, res) => {
      if(!err && res){
        app.message(app.translate('routes.home.attendance.reports.process has been queued'));
        props.handleSubmit();
      }
    } ));
  },
})

@connect((state) => ({
  values: getFormValues('renewed-report-builder-form')(state),
  isPristine: isPristine('renewed-report-builder-form')(state),
}),{

})
@autobind
/**
 *
 */
export default class Form extends React.PureComponent {
  static propTypes = {
    visible: PropTypes.bool,
    onCancel: PropTypes.func,
    onSubmit: PropTypes.func,
  };


  /**
   *
   * @return {XML}
   */
  render() {
    const {onCancel, visible, submit} = this.props;

    return (
      <Modal
        title={app.translate('routes.home.attendance.reports.Renewed form title')}
        visible={visible}
        wrapClassName="vertical-center-modal"
        onCancel={onCancel}
        footer={[
          <Button key="cancel" size="large" onClick={onCancel}>
            {app.translate('main.Cancel')}
          </Button>,
          <Button key="submit" type="primary" size="large" onClick={submit}>
            {app.translate('main.Submit')}
          </Button>,
        ]}
      >
        <Row
          style={{
            fontSize: '14px',
            lineHeight: '25px',
            maxHeight: '80vh',
            minHeight: '400px',
            overflowY: 'scroll'
          }}
        >
          <Col sm={12}>
            <Field
                name="dateFrom"
                label={app.translate('routes.home.attendance.reports.date from')}
                prefix={<MaterialIcon name="calender"/>}
                defaultValue={moment(moment().subtract(1, 'months')).format( 'YYYY/MM/DD')}
                max={this.props.values && this.props.values.dateTo}
                required
                component={Date}
            />
          </Col>


          <Col sm={12}>
            <Field
                name="dateTo"
                label={app.translate('routes.home.attendance.reports.date to')}
                prefix={<MaterialIcon name="calender"/>}
                defaultValue={moment(moment().subtract(1, 'months')).format( 'YYYY/MM/DD')}
                min={this.props.values && this.props.values.dateFrom}
                required
                component={Date}
            />
          </Col>

          <Col sm={24}>
            <Field
                name="positions"
                label={app.translate('routes.home.attendance.reports.Report positions')}
                required
                component={Position}
                reference={(input) => this.positionsChart = input}
                selected={ []}
                deletable={false}
            />
          </Col>

        </Row>

      </Modal>
    );
  }
}
